/* eslint-disable max-params -- these linting errors come up constantly with reducers */
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { RootState } from "@/store";
import { useAppDispatch } from "@/store/hooks";
import { extraReducersFactory } from "@/store/reducers/reset";

interface AttachmentsSliceState {
  invalidAttachments: string[];
}

const initialState: AttachmentsSliceState = {
  invalidAttachments: [],
};

const attachmentsSlice = createSlice({
  // NOTE: extraReducers is required for resetAllReduxSlices to work as expected
  extraReducers: extraReducersFactory(initialState),
  initialState,
  name: "attachments",
  reducers: {
    addInvalidAttachment: (state, action: PayloadAction<string>) => {
      state.invalidAttachments.push(action.payload);
    },
  },
});

const { addInvalidAttachment: addInvalidAttachmentAction } =
  attachmentsSlice.actions;

const selectInvalidAttachments = (state: RootState) =>
  state.attachments.invalidAttachments;

const useAttachmentsDispatch = () => {
  const dispatch = useAppDispatch();

  const addInvalidAttachment = (attachment: string) => {
    dispatch(addInvalidAttachmentAction(attachment));
  };

  return { addInvalidAttachment };
};

export { selectInvalidAttachments, useAttachmentsDispatch };

export default attachmentsSlice.reducer;
